import { CHZone } from "@app/area/model/ch-zone";
import { CHUuid } from "@app/root-store/actions";
import {
    createActionSet,
    createCrudActionSets,
    createDeletePromptActionSet,
    createNoPropsAction,
} from "@app/root-store/actions/action-creators";
import { ClareHomeDbCollection } from "@app/shared/resources/resource-objectifier";

const actionCategory = "CHZone";
const zoneDeviceCategory = "CHZone Device";

type ZoneFilterPayload = { filter: string } & CHUuid;
type ZoneDevicePayload = { zoneUid: string; deviceUid: string } & CHUuid;
type SetZoneDevicePayload = { zoneUid: string; devices: string[] } & CHUuid;
type ZoneDeviceResult = CHUuid;

type ActionPayload = CHUuid & { zone: CHZone };
type LoadActionPayload = CHUuid;
type BulkActionResult = {
    zones: ClareHomeDbCollection<CHZone>;
} & CHUuid;
type ActionResult = CHUuid & { zone: CHZone };

const {
    load: loadSet,
    create: createSet,
    update: updateSet,
    delete: deleteSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, BulkActionResult>(actionCategory);

export const { request: load, success: loadSuccess, failure: loadFailure } = loadSet;
export const { request: create, success: createSuccess, failure: createFailure } = createSet;
export const { request: update, success: updateSuccess, failure: updateFailure } = updateSet;
export const { request: deleteItem, success: deleteSuccess, failure: deleteFailure } = deleteSet;
export const { confirm: deleteConfirmation, dismiss: deleteConfirmationDismiss } =
    createDeletePromptActionSet<ActionPayload>(actionCategory);

export const {
    request: loadFiltered,
    success: loadFilteredSuccess,
    failure: loadFilteredFailure,
} = createActionSet<ZoneFilterPayload, BulkActionResult>(actionCategory, "Load Filtered");

export const {
    request: addZoneDevice,
    success: addZoneDeviceSuccess,
    failure: addZoneDeviceFailure,
} = createActionSet<ZoneDevicePayload, ZoneDeviceResult>(zoneDeviceCategory, "Add");

export const {
    request: removeZoneDevice,
    success: removeZoneDeviceSuccess,
    failure: removeZoneDeviceFailure,
} = createActionSet<ZoneDevicePayload, ZoneDeviceResult>(zoneDeviceCategory, "Remove");

export const {
    request: setZoneDevice,
    success: setZoneDeviceSuccess,
    failure: setZoneDeviceFailure,
} = createActionSet<SetZoneDevicePayload, ZoneDeviceResult>(zoneDeviceCategory, "Set");

/**
 * An action to clear the data in the store
 */
export const clear = createNoPropsAction(actionCategory, "Clear State");
